import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-manage',
	templateUrl: './manage.component.html',
	styleUrls: ['./manage.component.scss']
})
export class ManageComponent implements OnInit {

	@Input() data;
	@Output() manage = new EventEmitter();

	constructor() { }

	ngOnInit(): void {
	}

	manageInfo(data) {
		if (navigator.onLine) {
			this.manage.emit(data);
		}
	}

}
